module.exports = __webpack_public_path__ + "static/img/dn6.7113831.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dn6.png
// module id = 5YX0
// module chunks = 0